/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterItem } from './FilterItem';
import {
    FilterItemFromJSON,
    FilterItemFromJSONTyped,
    FilterItemToJSON,
    FilterItemToJSONTyped,
} from './FilterItem';

/**
 * 
 * @export
 * @interface PaginatedFilterItemList
 */
export interface PaginatedFilterItemList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilterItemList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFilterItemList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFilterItemList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<FilterItem>}
     * @memberof PaginatedFilterItemList
     */
    results: Array<FilterItem>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedFilterItemList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedFilterItemList interface.
 */
export function instanceOfPaginatedFilterItemList(value: object): value is PaginatedFilterItemList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedFilterItemListFromJSON(json: any): PaginatedFilterItemList {
    return PaginatedFilterItemListFromJSONTyped(json, false);
}

export function PaginatedFilterItemListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedFilterItemList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(FilterItemFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedFilterItemListToJSON(json: any): PaginatedFilterItemList {
    return PaginatedFilterItemListToJSONTyped(json, false);
}

export function PaginatedFilterItemListToJSONTyped(value?: PaginatedFilterItemList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(FilterItemToJSON)),
        'num_pages': value['numPages'],
    };
}

